import React, { useState } from "react";
import Button from "@mui/material/Button";
// css
import "../../css/style.css";
import theme from "../../css/theme";
// import logotur from "../../components/image/logotur_rectangle.png";
import logotur from "../../components/image/logotour_2023_transparent.png";
import { useNavigate } from "react-router-dom";

const Kids = () => {
  const navigate = useNavigate();
  const GreenKids = () => {
    window.location.href =
      "https://docs.google.com/forms/d/e/1FAIpQLSfhe_EVdBB6fN1gTyZlsLDpjT8YRMM23m2VcOGUrtChUNpe5A/viewform?embedded=true";
  };

  const [currentTime, setCurrentTime] = React.useState(+new Date());

  const startDate = 1749831703000;
  const endDateSponsori = 1750717694000;
  const endDateKids = 1751230799000;

  React.useEffect(() => {
    setTimeout(() => {
      // console.log(`Running Effect`, currentTime);
      setCurrentTime(+new Date());
    }, 5000);
  }, [currentTime]);

  console.log(`DEBUG timers: `, { currentTime, startDate, endDateSponsori, endDateKids });
  /*
   -> cand faci build: npm run build pt UI
   -> copiezi build-ul facut de UI in server>>public
  */
  return (
    <main className="main">
      <div>
        <img className="logo-home" src={logotur} alt="logo" width="400" />
      </div>
      <div className="logo-home">
        {/* DEBUG TIMERS */}
        {false && (
          <div>
            <div>Start inscrieri: {startDate - currentTime} </div>
            <div>Final inscrieri Sponsori: {endDateSponsori - currentTime} </div>
            <div>Final inscrieri Kids: {endDateKids - currentTime} </div>
          </div>
        )}
        {/* start time: */}
        {startDate < currentTime && currentTime < endDateSponsori && (
          <div className="timer-message">Inscrierile pentru Cursa Sponsorilor vor incepe in curand</div>
        )}
        {/*  mesaj de final : */}

        <div>
          {currentTime > endDateSponsori && (
            <div className="timer-message">Inscrierile pentru Cursa Sponsorilor au luat sfarsit</div>
          )}
          <Button
            className="kids-button"
            variant="contained"
            theme={theme}
            type="submit"
            onClick={() => {
              navigate("/login");
            }}
            disabled={startDate > currentTime || currentTime > endDateSponsori}
          >
            Cursa Sponsorilor
          </Button>

          {currentTime > endDateKids && (
            <div className="timer-message">Inscrierile pentru Green Day Kids au luat sfarsit</div>
          )}

          <Button
            className="kids-button"
            variant="contained"
            theme={theme}
            type="submit"
            onClick={GreenKids}
            // disabled={true}
            disabled={startDate > currentTime || currentTime > endDateKids}
          >
            Green Day Kids
          </Button>
        </div>
        {currentTime > endDateKids && (
          <div className="timer-message">
            <div>Concursul "GDK" va avea loc duminica 6 iulie 2025, incepand cu ora 10:00. </div>
            <div>Startul se va da din Piata Mare.</div>
            <div>
              In ziua concursului, va rog sa aveti la dumneavoastra o copie a certificatului de nastere al copilului.
            </div>
          </div>
        )}
      </div>
    </main>
  );
};

export default Kids;
